import React from 'react';
import { motion } from 'framer-motion';
import FloatingBackground from '../../Common/FloatingBackground/FloatingBackground';
import './Testimonials.css';

const Testimonials: React.FC = () => {

  return (
    <motion.section 
      className='testimonials modern-testimonials'
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      <FloatingBackground />
      <div className='container'>
        <div className='section-header'>
          <h2 className='modern-title'>
            Don't just take our word for it; our{' '}
            <span className='gradient-text'>customers say</span> it best
          </h2>
        </div>
        <div className='testimonials-grid'>
          <div className='testimonial-card'>
            <div className='testimonial-content'>
              <p>
                "Cinquity's AI-powered eCOA implementation has revolutionized
                our clinical trial efficiency. We achieved 60% faster patient
                onboarding and 98% data accuracy across all sites."
              </p>
            </div>
            <div className='testimonial-author'>
              <div className='author-info'>
                <h4>Dr. Sarah Chen</h4>
                <span>Clinical Operations Director, Global CRO Solutions</span>
              </div>
            </div>
          </div>
          <div className='testimonial-card'>
            <div className='testimonial-content'>
              <p>
                "The intelligent automation reduced our protocol compliance
                issues by 70%. Cinquity's platform delivers exactly what they
                promise—real-time insights at scale."
              </p>
            </div>
            <div className='testimonial-author'>
              <div className='author-info'>
                <h4>Michael Rodriguez</h4>
                <span>Chief Data Officer, BioTech Innovations</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default Testimonials;
